import { forwardRef, type HTMLAttributes } from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '../../../lib/utils';

const skeletonVariants = cva('block shrink-0 animate-pulse bg-muted', {
  variants: {
    shape: {
      rect: 'rounded',
      pill: 'rounded-full',
      circle: 'rounded-full aspect-square',
    },
  },
  defaultVariants: {
    shape: 'rect',
  },
});

export interface SkeletonProps
  extends HTMLAttributes<HTMLDivElement>, VariantProps<typeof skeletonVariants> {}

const Skeleton = forwardRef<HTMLDivElement, SkeletonProps>(
  ({ className, shape, ...props }, ref) => (
    <div
      ref={ref}
      data-slot="skeleton"
      aria-hidden="true"
      className={cn(skeletonVariants({ shape }), className)}
      {...props}
    />
  )
);
Skeleton.displayName = 'Skeleton';

export { Skeleton, skeletonVariants };
